module.exports = __webpack_public_path__ + "img/step2-b.07ed9bf5.png";